/**
 * SAML Error — displayed when SAML authentication fails.
 */
import { useSearchParams, Link } from 'react-router-dom'
import { ShieldX } from 'lucide-react'

const ERROR_MESSAGES: Record<string, string> = {
  invalid_response: 'La respuesta del proveedor de identidad no es válida o ha expirado.',
  replay_detected: 'Se detectó un intento de reutilización de sesión. Por seguridad, inicia sesión nuevamente.',
  idp_initiated_disabled: 'El inicio de sesión desde el portal del proveedor no está habilitado. Usa el botón SSO en la página de login.',
  account_inactive: 'Tu cuenta está desactivada. Contacta al administrador.',
  no_email: 'No se pudo obtener el email desde el proveedor de identidad.',
  callback_failed: 'Error al completar el inicio de sesión. Inténtalo de nuevo.',
  saml_disabled: 'SAML no está habilitado para esta empresa.',
  missing_token: 'Token de sesión faltante.',
  pos_license_no_web: 'Esta cuenta tiene una licencia de punto de venta: se usa solo en el terminal, con el PIN. Para entrar a Clobi se necesita una licencia completa.',
}

export function SAMLErrorPage() {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code') || 'unknown'
  const message = ERROR_MESSAGES[code] ?? 'Error desconocido en el inicio de sesión con SSO.'

  return (
    <div className="min-h-screen flex items-center justify-center bg-auth px-4">
      <div className="w-full max-w-md bg-surface rounded-2xl shadow-2xl p-8 text-center">
        <ShieldX size={48} className="text-danger-solid mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-content mb-2">Error de autenticación SSO</h2>
        <p className="text-sm text-content-muted mb-6">{message}</p>
        <Link
          to="/auth/login"
          className="inline-block py-2.5 px-6 bg-primary text-on-primary font-medium rounded-lg text-sm
            hover:bg-primary-hover transition-colors"
        >
          Volver al inicio de sesión
        </Link>
      </div>
    </div>
  )
}
